'use strict'
import { App, Controller, Router, View } from '../config/app.js'
import month from '../constants/month.js'
import * as Helper from '../helper.js'

class AccountController extends Controller
{
	async dashboard()
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { group: 'dashboard', tab: 'dashboard' }

		const topicId = Helper.hasRole('Patient') ? 'MyAccount.Dashboard.Patient' : 'MyAccount.Dashboard'
		
		View.create(
		{
			name: 'topic/dashboard',
			file: 'partial/topic',
			model: App.Store.modelCreate('topic', topicId)
		})

		App.Store.fetch('topic', topicId).catch(() => { })
		this.view.render()
	}

	async address()
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { tab: 'address', group: 'account' }
		return App.Store.page('address', 1)
			.catch(error => App.Component.HandleErrors(error))
			.finally(() => this.view.render())
	}

	async catalog()
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { group: 'order', tab: 'catalog' }

		let include = ['product', 'product.image']
		if (Helper.hasRole('Registered'))
		{
			include.push('product.child') // "Associated Products" of a "Grouped Product"
			include.push('product.price')
			include.push('product.promotion')
			include.push('product.variant')
		}

		App.Store.page('customercatalog', 1, 9, { 'include': include.join(',') })

		this.view.render()
	}

	async invoice()
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { tab: 'invoice', group: 'order' }

		View.create(
		{
			name: 'account/invoicePaymentSummary',
			model: { total: 0 }
		})

		this.view.render()
	}

	async invoicedetail(invoiceId)
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { tab: 'invoice', group: 'order' }

		const query = this.view.model.search?.view === 'patient' ? { view: 'patient' } : {}
		App.Store.fetch('invoice', `${invoiceId}/detail`, query)
			.then(invoice => this.view.model.sync(invoice))
			.catch(err => this.view.model.sync({ error: true, errorMessage: Helper.getErrorMessage(err)}))

		this.view.render()
	}

	async invoicepayment()
	{
		if (!this.view.model.data.invoices)
			return Router.navigate(Handlebars.helpers.route('plugin.apex.ui.account.invoice'))

		App.Store.model('customer', App.Config.customerId).myaccount = { tab: 'invoice', group: 'order' }

		View.create(
		{
			name: 'form/creditcard/select',
			file: 'partial/formCreditCardSelect',
			model: App.Store.modelCreate('walletcard')
		})

		// Credit card form dependencies
		return Promise.all(
			[
				App.Store.sync(month),
				App.Store.fetch('walletcard', 0),
				App.Store.fetch('country', 0, { include: 'stateProvince' })
			])
			.catch(err => 
			{
				if (!Array.isArray(err.data))
					document.querySelector('form[ui-action="invoice update"]')?.classList.add(App.cssClass.fail)
			})
			.finally(() => this.view.render())
	}

	async invoicepaymentconfirmation()
	{
		if (!this.view.model.data.attributes)
			return Router.navigate(Handlebars.helpers.route('plugin.apex.ui.account.invoice'))
		App.Store.model('customer', App.Config.customerId).myaccount = { tab: 'invoice', group: 'order' }
		this.view.render()
	}

	async message(messageId)
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { tab: 'messages', group: 'messages' }
		
		if (messageId)
		{
			View.create({ name: 'account/messageDetail', model: App.Store.modelCreate('message', messageId) })

			if (App.Store.paging('message'))
				App.Store.pagingReset('message')

			App.Store.fetch('message', messageId, { include: 'body' })
				.then(m =>
				{
					if (!m.attributes.isRead)
					{
						App.Store.patch('message', { id: messageId, isRead: true })
							.then(() =>
							{
								App.Store.model('customer', App.Config.customerId).attributes.newMessages -= 1
								App.View.cache('layout/headerMyAccount').render()
								App.View.cache('layout/headerNav').render()
							})
					}
				})
		}
		else
		{
			App.Store.page('message', 1)
		}

		this.view.model.messageId = messageId // Triggers this.view.render()
	}

	async payment()
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { tab: 'payment', group: 'order' }
		this.view.render()
	}

	async profile()
	{
		// Set the active tab and group for the My Account sub-navigation
		App.Store.model('customer', App.Config.customerId).myaccount = { tab: 'info', group: 'account' }

		View.create({
			name: 'account/customerProfile',
			model: Helper.currentUser()
		})

		this.view.render()
	}

	async savedcart()
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { group: 'order', tab: 'saved' }
		App.Store.fetch('savedcart', 0).catch(() => { })

		this.view.render()
	}

	async return()
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { tab: 'return', group: 'order' }
		this.view.render()
	}

	async returndetail()
	{
		const path = this.view.model.path
		const returnId = path[path.length - 1]
		const query = this.view.model.search?.view === 'patient' ? { view: 'patient' } : {}
		App.Store.model('customer', App.Config.customerId).myaccount = { tab: 'return', group: 'order' }
		this.view.render()
		App.Store.fetch('return', `${returnId}/detail`, query)
			.then(returnDetail => this.view.model.sync(returnDetail))
			.catch(err => this.view.model.sync({ error: true, errorMessage: Helper.getErrorMessage(err) }))
			.finally(() => this.view.render())
	}

	async wallet()
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { group: 'account', tab: 'creditcard' }
		return App.Store.page('walletcard', 1, 0, { 'filter[expired]': false })
			.catch(error => App.Component.HandleErrors(error))
			.finally(() => this.view.render())
	}

	async order(orderId)
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { group: 'order', tab: 'order' }
		if (orderId)
		{
			if (App.Store.paging('order'))
				App.Store.pagingReset('order')

			this.view.model.orderId = orderId

			let viewDetail = App.View.cache('account/orderDetail') || View.create({ name: 'account/orderDetail' })

			App.Store.fetch('order', orderId)
				.then(orderDetail => viewDetail.model.sync(orderDetail))
				.catch(err => viewDetail.model.sync({ error: true, errorMessage: Helper.getErrorMessage(err) }))
		}
		this.view.render()
	}

	async reorder(reorderId)
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { tab: 'reorder', group: 'order' }
		if (reorderId)
		{
			if (App.Store.paging('reorder'))
				App.Store.pagingReset('reorder')

			this.view.model.reorderId = reorderId

			let viewDetail = App.View.cache('account/reorderDetail') || View.create({ name: 'account/reorderDetail' })

			App.Store.fetch('reorder', reorderId, { include: '*' })
				.then(reorderDetail => viewDetail.model.sync(reorderDetail))
				.catch(err => viewDetail.model.sync({ error: true, errorMessage: Helper.getErrorMessage(err) }))
		}
		else
		{
			App.Store.page('reorder', 1, 20, { include: 'product.price' })
		}	
		
		this.view.render()
	}
}

export { AccountController }
